import React, { useEffect } from "react";
import { createPortal } from "react-dom";

// Full-screen image viewer: arrow keys / buttons step through `images`
// (upload paths), Escape or a click outside the image closes it.
export default function ImageLightbox({ images, index, onNavigate, onClose }) {
  const hasPrev = index > 0;
  const hasNext = index < images.length - 1;

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "ArrowLeft" && hasPrev) onNavigate(index - 1);
      if (e.key === "ArrowRight" && hasNext) onNavigate(index + 1);
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [index, hasPrev, hasNext, onNavigate, onClose]);

  const navBtn = {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    background: "rgba(0,0,0,0.45)",
    border: "none",
    color: "#fff",
    fontSize: 32,
    lineHeight: 1,
    padding: "12px 18px",
    cursor: "pointer",
    borderRadius: 6,
    zIndex: 1,
  };

  return createPortal(
    <div
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.85)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        cursor: "zoom-out",
      }}
    >
      <button
        onClick={onClose}
        style={{
          position: "absolute",
          top: 16,
          right: 20,
          background: "none",
          border: "none",
          color: "#fff",
          fontSize: 32,
          cursor: "pointer",
          lineHeight: 1,
        }}
        aria-label="Close"
      >
        &times;
      </button>
      {hasPrev && (
        <button
          style={{ ...navBtn, left: 16 }}
          onClick={(e) => {
            e.stopPropagation();
            onNavigate(index - 1);
          }}
          aria-label="Previous"
        >
          &#8249;
        </button>
      )}
      <img
        src={`${process.env.REACT_APP_API_UPLOAD_URL}${images[index]}`}
        alt={`Preview ${index + 1}`}
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: "90vw",
          maxHeight: "90vh",
          objectFit: "contain",
          borderRadius: 8,
          boxShadow: "0 8px 32px rgba(0,0,0,0.5)",
          cursor: "default",
        }}
      />
      {hasNext && (
        <button
          style={{ ...navBtn, right: 16 }}
          onClick={(e) => {
            e.stopPropagation();
            onNavigate(index + 1);
          }}
          aria-label="Next"
        >
          &#8250;
        </button>
      )}
      {images.length > 1 && (
        <div
          style={{
            position: "absolute",
            bottom: 20,
            color: "rgba(255,255,255,0.7)",
            fontSize: 14,
          }}
        >
          {index + 1} / {images.length}
        </div>
      )}
    </div>,
    document.body,
  );
}
